var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zui-loading"},[_c('div',{staticClass:"zui-loading-content"},[_c('div',{staticClass:"zui-loading-dot white"}),_vm._v(" "),_c('div',{staticClass:"zui-loading-dot"}),_vm._v(" "),_c('div',{staticClass:"zui-loading-dot"}),_vm._v(" "),_c('div',{staticClass:"zui-loading-dot"}),_vm._v(" "),_c('div',{staticClass:"zui-loading-dot"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22fde9e5","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 1398
// module chunks = 0